/** Shared helpers for floor plan SVG loading (inline view + dialog). */

export function assetOrigin() {
  if (typeof window === "undefined") {
    return "";
  }
  return window.location.hostname === "localhost"
    ? "https://dev-vue.imclv.com"
    : "https://adhub.andmoreart.com";
}

export function joinUrl(path) {
  if (!path) {
    return "";
  }
  if (/^https?:\/\//i.test(path)) {
    return path;
  }
  const base = assetOrigin().replace(/\/$/, "");
  const p = String(path).replace(/^\//, "");
  return `${base}/${p}`;
}

export function normalizeFloorsList(floors) {
  if (floors == null || floors === "") {
    return [];
  }
  if (Array.isArray(floors)) {
    return floors;
  }
  if (typeof floors === "object") {
    return Object.values(floors).filter(
      (f) => f != null && typeof f === "object",
    );
  }
  return [];
}

export function parseFloorSvgFetched(raw) {
  const text = (raw || "").trim();
  const fallbackViewBox = "0 0 612 792";
  const looksLikeSvgMarkup =
    /<(svg|g|path|defs|rect|circle|line|polyline|polygon|text)\b/i.test(
      text,
    );

  if (!text) {
    return { inner: "", viewBox: fallbackViewBox, parseError: "empty" };
  }

  let doc;
  try {
    doc = new DOMParser().parseFromString(text, "image/svg+xml");
  } catch (e) {
    return looksLikeSvgMarkup
      ? { inner: text, viewBox: fallbackViewBox, parseError: null }
      : { inner: "", viewBox: fallbackViewBox, parseError: "domparser" };
  }

  const err = doc.querySelector("parsererror");
  const svgEl = doc.querySelector("svg");
  if (svgEl && !err) {
    const vb = svgEl.getAttribute("viewBox");
    return {
      inner: svgEl.innerHTML.trim(),
      viewBox: vb && vb.trim() ? vb.trim() : fallbackViewBox,
      parseError: null,
    };
  }

  if (looksLikeSvgMarkup) {
    return { inner: text, viewBox: fallbackViewBox, parseError: null };
  }

  return { inner: "", viewBox: fallbackViewBox, parseError: "invalid_svg" };
}
